import { render } from "./PainelMemoriaEnviarMensagem.vue?vue&type=template&id=4c200909&scoped=true"
import script from "./PainelMemoriaEnviarMensagem.vue?vue&type=script&lang=js"
export * from "./PainelMemoriaEnviarMensagem.vue?vue&type=script&lang=js"

import "./PainelMemoriaEnviarMensagem.vue?vue&type=style&index=0&id=4c200909&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c200909"]])

export default __exports__